import { cn } from '@streetferret/utils';

export interface TextProps {
  className?: string;
  children?: React.ReactNode;
  dimmed?: boolean;
}
export function Text({ className, children, dimmed }: TextProps) {
  return (
    <div
      className={cn(
        { 'text-muted-foreground': dimmed },
        className,
      )}>
      {children}
    </div>
  );
}
